export const lngRole = {
  teacher: 'r-teacher',
  officer: 'r-officer',
  accountant: 'r-accountant',
  leader: 'r-leader',
  administrator: 'r-admin',
  seller: 'r-seller',
  censor: 'r-censor',
  highest: 'r-highest',
};

export const lngStatus = {
  new: 'New',
  pending: 'Pending',
  confirmed: 'Confirmed',
  processing: 'Processing',
  shipping: 'Shipped',
  delivered: 'Delivered',
  completed: 'Completed',
  cancelled: 'Cancelled',
  onHold: 'On_Hold',
  reserved: 'Reserved',
  returned: 'Returned',
  refunded: 'Refunded',
  failed: 'Failed',
  awaitingPayment: 'Awaiting_Payment',
  partiallyShipped: 'Partially_Shipped',
  backordered: 'Backordered',
  awaitingFulfillment: 'Awaiting_Fulfillment',
};

export const lngSlot = {
  morning: 'slot_1',
  evening: 'slot_2',
  night: 'slot_3',
};
